<template>
  <div>invoices</div>
</template>

<script>
export default {};
</script>

<style></style>
